import React from 'react';
import { FormattedMessage } from 'react-intl';
import { currencyToSign } from '../../../../utils/utils';

const getOfferStats = (stats = [], type, period, sign) => {
    const stat = stats.find(stat => stat.period === period);
    return getStats(stat[type], undefined, sign);
};

const getStats = (stat, isNew, sign) =>
    isNew ? 'NEW' : stat > 0 ? `${stat} ${currencyToSign(sign)}` : '—';

export default ({ stats, currencies }) => {
    const keys = Object.keys(stats);

    const [baseCurrency] = currencies;

    return (
        <div className='offer-card-stats'>
            <p className="offers-list-block-title">
                <FormattedMessage id="offers.stats" defaultMessage="Indicators" />
            </p>
            <ul className="list-unstyled offers-list-stats">
                <li className="offers-list-stats-item">
                    <span className="offers-list-stats-name">CR: </span>
                    <span className="offers-list-stats-value">
                        {getOfferStats(stats, 'cr', 'week', '%')}
                    </span>
                </li>

                <li className="offers-list-stats-item">
                    <span className="offers-list-stats-name">EPC: </span>
                    <span className="offers-list-stats-value">
                        {getOfferStats(stats, 'epc', 'week', baseCurrency)}
                    </span>
                </li>
            </ul>
        </div>
    )
}